import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {MxMaterialModule} from '../../material/mx-material.module';
import {MxButtonModule} from '../mx-button/mx-button.module';
import {MxSharedModule} from '../../shared/mx-shared.module';
import {MxFormComponent} from './components/mx-form/mx-form.component';
import {MxObjectFormDialogComponent} from './components/mx-object-form-dialog/mx-object-form-dialog.component';
import {MxObjectFormComponent} from './components/mx-object-form/mx-object-form.component';
import {MxDynamicFieldsModule} from './modules/mx-dynamic-fields/mx-dynamic-fields.module';

@NgModule({
    imports: [
        CommonModule,
        MxButtonModule,
        MxMaterialModule,
        MxSharedModule,
        MxDynamicFieldsModule,
        TranslateModule
    ],
    exports: [
        MxFormComponent,
        MxDynamicFieldsModule,
        MxObjectFormComponent,
        MxObjectFormDialogComponent
    ],
    declarations: [
        MxFormComponent,
        MxObjectFormComponent,
        MxObjectFormDialogComponent
    ]
})
export class MxFormModule {
}
